<script>
import { assoc, propEq } from 'rambda'

export default {
  methods: {
    addAlternative(alternativeToLaptopId, laptopId) {
      this.setLaptopIsSelected({
        alternativeToLaptopId,
        laptopId,
      }, true)
    },
    promoteAlternative(laptopId) {
      const setAlternativeToLaptopId = assoc('alternativeToLaptopId')
      const resetAlternative = setAlternativeToLaptopId(null)

      const { alternativeToLaptopId } = this.articleLaptops
        .find(propEq('laptopId', laptopId))

      const articleLaptops = this.articleLaptops
        .map((articleLaptop) => {
          // article laptop promoted
          if (articleLaptop.laptopId === laptopId) {
            return resetAlternative(articleLaptop)
          }

          if (
            // previously main laptop
            articleLaptop.laptopId === alternativeToLaptopId ||
            // other alternatives
            articleLaptop.alternativeToLaptopId === alternativeToLaptopId
          ) {
            return setAlternativeToLaptopId(laptopId, articleLaptop)
          }

          return articleLaptop
        })

      this.setArticleLaptops(articleLaptops)
    },
    removeAlternative(alternativeToLaptopId, laptopId) {
      this.setLaptopIsSelected({
        alternativeToLaptopId,
        laptopId,
      }, false)
    },

    getAlternativeTo(laptopId) {
      const articleLaptopId = this.articleLaptops
        .find(laptop => laptop.laptopId === laptopId)
        ?.alternativeToLaptopId

      if (!articleLaptopId) return null

      const laptopEvaluation = this.laptopEvaluations
        .find(laptop => laptop.id === articleLaptopId)

      if (!laptopEvaluation) {
        console.warn('no laptop evaluation: articleLaptopId', articleLaptopId)
        return null
      }

      return {
        id: laptopEvaluation.id,
        name: laptopEvaluation.name,
      }
    },
    getLaptopAlternatives(laptopId) {
      const alternatives = this.articleLaptops
        .filter(laptop => laptop.alternativeToLaptopId === laptopId)

      return alternatives
        .map((alternative) => {
          const laptop = this
            .laptopEvaluations
            .find(laptopEvaluation => laptopEvaluation.id === alternative.laptopId)

          // when previously selected laptop becomes archived or has null price
          if (!laptop) return

          return {
            id: laptop.id,
            name: laptop.name,
            totalScore: laptop.totalScore,
            totalScoreNth: laptop.totalScoreNth,
            valueScore: laptop.valueScore,
            price: laptop.price,
          }
        })
        .filter(Boolean)
    },
  },
  render: () => '',
}
</script>
